export default __webpack_public_path__ + "static/media/Covid.32e9a225.png";